const pagesTitleCat: Array<string> = [
    'Datos personales'
];

const pagesSubTitleCat: Array<string> = [
    '¡Queremos conocerte! Ingresá los siguientes datos, según tu documento de identidad'
];

const typeDocument = [
    { value: '1', text: 'Cédula' },
    { value: '2', text: 'Pasaporte' },
    { value: '3', text: 'Residencia' },
];

const txtAcceptTerm = "Acepto que he leído y consecuentemente brindo mi consentimiento a SEGUROS LAFISE para el uso de mi información según lo indicado en las Políticas de Privacidad, Términos y Condiciones.";


export { pagesTitleCat, pagesSubTitleCat, typeDocument, txtAcceptTerm };